import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { api } from "../api/client.js";

export function useCancelReview(reviewId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => api.cancelReview(reviewId),
    onSuccess: () => {
      toast.success("Review abgebrochen");
      void queryClient.invalidateQueries({ queryKey: ["review", reviewId] });
      void queryClient.invalidateQueries({ queryKey: ["reviews"] });
    },
    onError: (err) => toast.error("Review konnte nicht abgebrochen werden", { description: (err as Error).message }),
  });
}
